import React from 'react';

/**
 * A library toolbar's search field with its clear (×) button: the `.library-toolbar__search-wrap`
 * markup in global.css. Put it inside `.library-toolbar__search` (add `--wide` to let it fill
 * the row), followed by the Filters button on phones.
 */
export function LibrarySearchInput({ value, onChange, placeholder, label }: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Accessible name, e.g. "Search events". */
  label: string;
}) {
  return (
    <div className="library-toolbar__search-wrap">
      <input
        className="search-input"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-label={label}
      />
      {value.trim().length > 0 ? (
        <button
          type="button"
          className="library-toolbar__search-clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
          title="Clear search"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      ) : null}
    </div>
  );
}

export default LibrarySearchInput;
